import type { ComponentType } from "react";
import { Route } from "react-router-dom";

// Shared AI Workbench route tree, consumed inline by the router and tests so
// both stay in sync. A fragment-returning function (not a component) because
// react-router only flattens <Route> and <Fragment> children.
export function workbenchRoutes(Workbench: ComponentType) {
  return (
    <>
      <Route element={<Workbench />} index />
      <Route element={<Workbench />} path="dataset/:datasetId" />
      <Route element={<Workbench />} path="dataset/:datasetId/item/:itemId" />
      <Route element={<Workbench />} path="dataset/:datasetId/experiments" />
      <Route
        element={<Workbench />}
        path="dataset/:datasetId/experiments/runs/:runName"
      />
      <Route
        element={<Workbench />}
        path="dataset/:datasetId/experiments/:experimentId"
      />
      <Route
        element={<Workbench />}
        path="dataset/:datasetId/experiments/:experimentId/items/:runItemId"
      />
    </>
  );
}
